import React from "react";

const WhyChooseUs = () => {
  const milestones = [
    {
      number: 1,
      title: "Your Journey Begins",
      description: "Discover our range of courses designed to kickstart your learning journey and career transformation.",
    },
    {
      number: 2,
      title: "Learn from Experts",
      description: "Gain insights from industry leaders and subject matter experts to master in-demand skills.",
    },
    {
      number: 3,
      title: "Hands-On Projects",
      description: "Work on real-world projects that help you apply your knowledge and build a strong portfolio.",
    },
    {
      number: 4,
      title: "Get Certified",
      description: "Earn industry-recognized certifications that validate your skills and boost your resume.",
    },
    {
      number: 5,
      title: "Job Assistance",
      description: "Receive guidance and resources to help you land your dream job with top companies.",
    },
    {
      number: 6,
      title: "Lifetime Access",
      description: "Enjoy lifetime access to course materials and stay updated with the latest trends and technologies.",
    },
  ];

  const circleStyle = {
    backgroundColor: "#ff0000",
    color: "white",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    fontSize: "18px",
  };

  return (
    <div className="container py-5" style={{marginTop:"30px"}}>
      {/* Heading Section */}
      <div className="text-center mb-5">
        <h2 className="display-5 fw-bold text-danger title split-collab">
          Why Choose Us
        </h2>
        <hr className="w-25 mx-auto border-2 border-dark title split-collab" style={{ opacity: 1 }} />
      </div>

      {/* Milestone Cards */}
      <div 
      className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 "
       data-sal-delay="150"
        data-sal="slide-up"
        data-sal-duration="800"
      >
        
        {milestones.map((item) => (
          <div key={item.number} className="col">
            <div className="card p-3" style={{ border: "1px solid #ddd", borderRadius: "12px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)" }}>
              <div className="card-body d-flex flex-column">
                <div className="d-flex align-items-center mb-3">
                  <div style={circleStyle}>{item.number}</div>
                  <h4 className="ms-3 mb-0 flex-grow-1">{item.title}</h4>
                </div>
                <p className="card-text">{item.description}</p>
                <div className="text-end mt-3" style={{ minHeight: "50px" }}>
                  {/* Placeholder for future image */}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChooseUs;